import {
  BottomSheetHeader as BottomSheetHeaderBase,
  type BottomSheetHeaderProps,
} from "@clipboard-health/ui-components";

import { ButtonInternalLink } from "./ButtonInternalLink";

export function BottomSheetHeader(props: Omit<BottomSheetHeaderProps, "LinkComponent">) {
  return <BottomSheetHeaderBase {...props} LinkComponent={ButtonInternalLink} />;
}
